import { cn } from "@/lib/utils";
import { ReactNode } from "react";

/**
 * One setting: a label, an optional line under it, and the control on the
 * right. The whole row is the hit area, so a switch is not the only 40px the
 * user can tap. Switch stops its own clicks from bubbling, so it is not
 * toggled twice.
 */
export const SettingRow = ({
  label,
  description,
  control,
  onClick,
  disabled = false,
  className,
}: {
  label: ReactNode;
  description?: ReactNode;
  control: ReactNode;
  /** Fires for a click anywhere on the row outside the control. */
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}) => (
  <div
    role="presentation"
    onClick={disabled ? undefined : onClick}
    className={cn(
      "flex h-12 items-center gap-3 px-3",
      onClick && !disabled && "cursor-pointer",
      disabled && "opacity-50",
      className,
    )}
  >
    <div className="flex min-w-0 flex-1 flex-col gap-0.5">
      <span className="text-sm font-semibold text-neutral-100">{label}</span>
      {description && (
        <span className="text-xs text-foreground-muted">{description}</span>
      )}
    </div>
    <div className="shrink-0">{control}</div>
  </div>
);
